






















































































































































































































import {Vue, Component} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import CompCheckBox from '@/components/common/CompCheckBoxButton.vue';
import CompRadioButton from '@/components/common/CompRadioButton.vue';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import RadioElement from '@/components/common/RadioElement.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import {getToday, addMonth} from '@/utils/dateUtils';
// import {popupResize} from '@/utils/ncp';
import {i18nInObjectList} from '@/utils/i18n';

import {Mall, GetMembersRequest, GetMemberGradesRequest, GetMemberGroupsRequest, Member, Grade, Group} from 'supporter';
import { getLocalStorageMalls } from '@/utils/commonUtils';

@Component({
  components: {PageTitle, CompSelectBox, CompCheckBox, CompRadioButton, PeriodDateCalendar, RadioElement, ItemTable}
})
export default class List extends Vue {
  private malls: Mall[] = getLocalStorageMalls();

  // query
  private memberNos: number[] = [];
  private mallNo: string = '';
  private searchTypeValue: string = 'USER_ID';
  private detailSearchFormDisplayFlag = false;
	

  private getMemberRequest: GetMembersRequest = {
    params: {
      mallNo: Number(this.mallNo),
      page: 1,
      pageSize: 30
    }
  };

  private members: Member[] = [];
  private memberGrades: Grade[] = [];
  private memberGroups: Group[] = [];

  private joinDatePeriodUse = 'NOTUSE';
  private combinedFlag = 'NOTUSE';
  private lastLoginDate = 'NOTUSE';

  private membersCount: number = 0;
	
	private selectedMemberMap = {};
	private get selectedMemberCount() {
		return Object.values(this.selectedMemberMap).flat()?.length ?? 0;
	};
	
	private resetSelectedMemberMap() {
		this.selectedMemberMap = {};
	}

  private size: number = 30;

  private signUpDateFrom: string = addMonth(new Date(), -3);
  private signUpDateTo: string = getToday();
  private lastLoginDateFrom: string = addMonth(new Date(), -3);
  private lastLoginDateTo: string = getToday();
  private combinedDateFrom: string = addMonth(new Date(), -3);
  private combinedDateTo: string = getToday();

  // 검색어
  private searchType = [
    {
      searchTypeValue: 'USER_ID',
      searchTypeName: 'MEMBER_LIST_ID'
    },
    {
      searchTypeValue: 'MEMBER_NO',
      searchTypeName: 'MEMBER_LIST_MEMBER_NO'
    },
    {
      searchTypeValue: 'NAME',
      searchTypeName: 'MEMBER_LIST_NAME'
    },
    {
      searchTypeValue: 'NICKNAME',
      searchTypeName: 'MEMBER_LIST_NICKNAME'
    },
    {
      searchTypeValue: 'EMAIL',
      searchTypeName: 'MEMBER_LIST_MAILADDRESS'
    },
    {
      searchTypeValue: 'MOBILE',
      searchTypeName: 'MEMBER_LIST_MOBILE'
    },
    {
      searchTypeValue: 'ORDER_NO',
      searchTypeName: 'MEMBER_LIST_ORDER_NO'
    }
  ];

  private typesCheckboxOptions = {
    name: 'types',
    hasAll: true,
    data: [
      {
        id: 'ALL',
        value: 'ALL',
        dispaly: 'COMMON_ALL'
      },
      {
        id: 'MALL',
        value: 'MALL',
        dispaly: 'COMMON_MALLTYPE_MALL'
      },
      {
        id: 'PAYCO',
        value: 'PAYCO',
        dispaly: 'COMMON_MALLTYPE_PAYCO'
      },
      {
        id: 'NAVER',
        value: 'NAVER',
        dispaly: 'COMMON_MALLTYPE_NAVER'
      },
      {
        id: 'KAKAO',
        value: 'KAKAO',
        dispaly: 'COMMON_MALLTYPE_KAKAO'
      },
      {
        id: 'FACEBOOK',
        value: 'FACEBOOK',
        dispaly: 'COMMON_MALLTYPE_FACEBOOK'
      },
      {
        id: 'LINE',
        value: 'LINE',
        dispaly: 'COMMON_MALLTYPE_LINE'
      }
    ]
  };

  private signUpRouteRadioOptions = {
    name: 'joinType',
    data: [
      {
        id: 'joinType_1',
        value: '',
        dispaly: 'COMMON_ALL'
      },
      {
        id: 'joinType_2',
        value: 'PC_WEB',
        dispaly: 'COMMON_PC_WEB'
      },
      {
        id: 'joinType_3',
        value: 'MOBILE_WEB',
        dispaly: 'COMMON_MOBILE_WEB'
      },
      {
        id: 'joinType_4',
        value: 'MOBILE_APP',
        dispaly: 'COMMON_MOBILE_APP'
      }
    ]
  };

  private certifiedRadioOptions = {
    name: 'certified',
    data: [
      {
        id: 'principalCertificationYn0',
        value: '',
        dispaly: 'COMMON_ALL'
      },
      {
        id: 'principalCertificationYn1',
        value: true,
        dispaly: 'COMMON_CERTIFIED_Y'
      },
      {
        id: 'principalCertificationYn2',
        value: false,
        dispaly: 'COMMON_CERTIFIED_N'
      }
    ]
  };

  private genderRadioOptions = {
    name: 'gender',
    data: [
      {
        id: 'gender_ALL',
        value: '',
        dispaly: 'COMMON_ALL'
      },
      {
        id: 'gender_MALE',
        value: 'MALE',
        dispaly: 'COMMON_GANDER_MALE'
      },
      {
        id: 'gender_FEMALE',
        value: 'FEMALE',
        dispaly: 'COMMON_GANDER_FEMALE'
      }
    ]
  };

  private memberStatus = [
    {
      value: 'WAITING',
      name: 'MEMBER_LIST_STATUS1'
    },
    {
      value: 'ACTIVE',
      name: 'MEMBER_LIST_STATUS2'
    },
    {
      value: 'FREEZE',
      name: 'MEMBER_LIST_STATUS3'
    },
    {
      value: 'PAUSED',
      name: 'MEMBER_LIST_STATUS4'
    }
  ];

  private ageGroups = [
    {
      name: 'MEMBER_LIST_AGE_COUNT1',
      value: 10
    },
    {
      name: 'MEMBER_LIST_AGE_COUNT2',
      value: 20
    },
    {
      name: 'MEMBER_LIST_AGE_COUNT3',
      value: 30
    },
    {
      name: 'MEMBER_LIST_AGE_COUNT4',
      value: 40
    },
    {
      name: 'MEMBER_LIST_AGE_COUNT5',
      value: 50
    },
    {
      name: 'MEMBER_LIST_AGE_OVER_COUNT6',
      value: 60
    }
  ];

  private loginMonthGroups = [
    {
      value: 1,
      name: 'COMMON_DATA1'
    },
    {
      value: 3,
      name: 'COMMON_DATA2'
    },
    {
      value: 6,
      name: 'COMMON_DATA3'
    },
    {
      value: 12,
      name: 'COMMON_DATA4'
    }
  ];

  private appPushAgreedRadioOptions = {
    name: 'appPushAgreed',
    data: [
      {
        id: 'pushNotificationAgreeYn0',
        value: '',
        dispaly: 'COMMON_ALL'
      },
      {
        id: 'pushNotificationAgreeYn1',
        value: true,
        dispaly: 'COMMON_AGREED'
      },
      {
        id: 'pushNotificationAgreeYn2',
        value: false,
        dispaly: 'COMMON_NOT_AGREED'
      }
    ]
  };

  private smsAgreedRadioOptions = {
    name: 'smsAgreed',
    data: [
      {
        id: 'pushNotificationAgreeYn0',
        value: '',
        dispaly: 'COMMON_ALL'
      },
      {
        id: 'pushNotificationAgreeYn1',
        value: true,
        dispaly: 'COMMON_AGREED'
      },
      {
        id: 'pushNotificationAgreeYn2',
        value: false,
        dispaly: 'COMMON_NOT_AGREED'
      }
    ]
  };

  private combinedRadioOptions = {
    name: 'combined',
    data: [
      {
        id: 'linkedYn0',
        value: '',
        dispaly: 'COMMON_ALL'
      },
      {
        id: 'linkedYn1',
        value: true,
        dispaly: 'MEMBER_LIST_COMBINED_AGREE'
      },
      {
        id: 'linkedYn2',
        value: false,
        dispaly: 'MEMBER_LIST_COMBINED_NOTAGREE'
      }
    ]
  };

  private emailAgreedRadioOptions = {
    name: 'emailAgreed',
    data: [
      {
        id: 'directMailAgreeYn0',
        value: '',
        dispaly: 'COMMON_ALL'
      },
      {
        id: 'directMailAgreeYn1',
        value: true,
        dispaly: 'COMMON_AGREED'
      },
      {
        id: 'directMailAgreeYn2',
        value: false,
        dispaly: 'COMMON_NOT_AGREED'
      }
    ]
  };

  private joinDatePeriodUseGroups = [
    {
      value: 'NOTUSE',
      name: 'MEMBER_SEARCH_DATE_ALL'
    },
    {
      value: 'USE',
      name: 'MEMBER_SEARCH_DATE_PEROID'
    }
  ];

  private combinedFlagGroups = [
    {
      value: 'NOTUSE',
      name: 'COMMON_NOT_USE'
    },
    {
      value: 'USE',
      name: 'COMMON_USE'
    },
    {
      value: 'NODATE',
      name: 'COMMON_NOT_DATA2'
    }
  ];

  private lastLoginDateGroups = [
    {
      value: 'NOTUSE',
      name: 'COMMON_NOT_USE'
    },
    {
      value: 'USE',
      name: 'COMMON_USE'
    },
    {
      value: 'NOLOGIN',
      name: 'COMMON_NOLOGIN'
    }
  ];

  private async initRequest() {
    if (this.detailSearchFormDisplayFlag) {
      this.getMemberRequest = {
        params: {
          mallNo: Number(this.mallNo),
          page: 1,
          pageSize: 30,
          types: 'ALL',
          searchType: 'USER_ID',
          keyword: undefined,
          openIdProviders: undefined,
          gradeNos: undefined,
          groupNos: undefined,
          status: undefined,
          blacklisted: undefined,
          certified: '',
          reserveBalanceFrom: undefined,
          reserveBalanceTo: undefined,
          loginCountFrom: undefined,
          loginCountTo: undefined,
          notLoginMonth: undefined,
          gender: '',
          ageGroup: undefined,
          appPushAgreed: '',
          smsAgreed: '',
          emailAgreed: '',
          combined: '',
          combinedDateFrom: undefined,
          combinedDateTo: undefined,
          lastLoginDateFrom: undefined,
          lastLoginDateTo: undefined,
          signUpRoute: '',
          signUpDateFrom: undefined,
          signUpDateTo: undefined
        }
      };
      this.joinDatePeriodUse = 'NOTUSE';
      this.lastLoginDate = 'ALL';
      this.combinedFlag = 'ALL';
    } else {
      this.getMemberRequest = {
        params: {
          mallNo: Number(this.mallNo),
          page: 1,
          pageSize: 30,
          types: 'ALL',
          searchType: 'USER_ID'
        }
      };
    }
  }

  private getSearchParams() {
    const {types} = this.getMemberRequest.params;
    this.getMemberRequest.params.types = types === 'ALL' ? 'MALL,SYNC_ID,OPEN_ID' : types;
    if (this.$refs.joinDatePeriod && this.joinDatePeriodUse === 'USE') {
      this.getMemberRequest.params.signUpDateFrom = this.signUpDateFrom;
      this.getMemberRequest.params.signUpDateTo = this.signUpDateTo;
    } else {
      this.getMemberRequest.params.signUpDateFrom = undefined;
      this.getMemberRequest.params.signUpDateTo = undefined;
    }
    if (this.$refs.lastLoginPeriod && this.lastLoginDate === 'USE') {
      this.getMemberRequest.params.lastLoginDateFrom = this.lastLoginDateFrom;
      this.getMemberRequest.params.lastLoginDateTo = this.lastLoginDateTo;
    } else {
      this.getMemberRequest.params.lastLoginDateFrom = undefined;
      this.getMemberRequest.params.lastLoginDateTo = undefined;
    }
    if (this.$refs.combinedPeriod && this.combinedFlag === 'USE') {
      this.getMemberRequest.params.combinedDateFrom = this.combinedDateFrom;
      this.getMemberRequest.params.combinedDateTo = this.combinedDateTo;
    } else {
      this.getMemberRequest.params.combinedDateFrom = undefined;
      this.getMemberRequest.params.combinedDateTo = undefined;
    }

    this.getMemberRequest.params.searchType = this.getMemberRequest.params.keyword ? this.searchTypeValue :'ALL';
  }

  // 조회
  private async search(page: number = 1, size?: number, resetSelectedMembers?: boolean) {
    if (size) {
      this.size = size;
    }
		
		if (resetSelectedMembers) {
			this.selectedMemberMap = {};
		}

    this.getSearchParams();
    this.getMemberRequest.params.page = page;
    this.getMemberRequest.params.pageSize = this.size;
    await this.$api
      .getMembers(this.getMemberRequest)
      .then((res) => {
        if (res.data) {
          const {types} = this.getMemberRequest.params;
          this.getMemberRequest.params.types = types === 'MALL,SYNC_ID,OPEN_ID' ? 'ALL' : types;
					
					const selectedMembers = this.selectedMemberMap[page];
          this.members = res.data.contents.map(({ memberNo, ...rest }) => ({
	          ...rest,
	          memberNo,
	          _attributes: {
		          checked: selectedMembers?.includes(memberNo)
	          }
          }));
          this.membersCount = res.data.totalCount;
          this.gridProps.options.pageOptions.page = page;
          this.gridProps.options.pageOptions.perPage = this.size;
          this.gridProps.options.pageOptions.totalCount = res.data.totalCount;
        } else {
          alert(this.$t('MEMBER_LIST_ALERT_NON_MEMBER'));
        }
      });
  }

  get getMemberGradesRequest(): GetMemberGradesRequest {
    return {
      params: {
        mallNo: this.getMemberRequest.params.mallNo
      }
    };
  }
  get getMemberGroupsRequest(): GetMemberGroupsRequest {
    return {
      params: {
        mallNo: this.getMemberRequest.params.mallNo
      }
    };
  }

  private getMemberGrades() {
    this.$api.getMemberGrades(this.getMemberGradesRequest).then((ret) => {
      this.memberGrades = ret.data.filter((memberGrade) => {
        if (memberGrade.used) return memberGrade;
      });
      this.memberGrades.reverse();
    });
  }
  private getMeberGroups() {
    this.$api.getMemberGroups(this.getMemberGroupsRequest).then((ret) => {
      this.memberGroups = ret.data;
    });
  }

  private displaydetailSearchForm() {
    this.getMemberRequest = {
      params: {
        mallNo: this.getMemberRequest.params.mallNo,
        page: this.getMemberRequest.params.page,
        pageSize: this.getMemberRequest.params.pageSize,
        searchType: 'USER_ID',
        keyword: undefined,
        types: 'ALL',
        openIdProviders: undefined,
        gradeNos: undefined,
        groupNos: undefined,
        status: undefined,
        blacklisted: undefined,
        certified: '',
        reserveBalanceFrom: undefined,
        reserveBalanceTo: undefined,
        loginCountFrom: undefined,
        loginCountTo: undefined,
        notLoginMonth: undefined,
        gender: '',
        ageGroup: undefined,
        appPushAgreed: '',
        smsAgreed: '',
        emailAgreed: '',
        combined: '',
        combinedDateFrom: undefined,
        combinedDateTo: undefined,
        lastLoginDateFrom: undefined,
        lastLoginDateTo: undefined,
        signUpRoute: '',
        signUpDateFrom: undefined,
        signUpDateTo: undefined
      }
    };
    this.detailSearchFormDisplayFlag = !this.detailSearchFormDisplayFlag;
    this.getMemberGrades();
    this.getMeberGroups();
  }

  private plus(e: Event) {
    if (Number((e.target as HTMLInputElement).value) < 0) {
      (e.target as HTMLInputElement).value = '';
    }
  }

  private contentBottomOption = {
    haveExcelDownBtn: false,
    onLoadSearch: false,
    haveConfigBtn: false
  };

  private gridProps = {
    columns: [
      {
        header: 'MEMBER_LIST_MEMBER_NO',
        name: 'memberNo',
        align: 'center',
        minWidth: 80,
        formatter: (cell: any) => {
          return `<a href="javascript:window.open(\'/member/popup/crm/${cell.value}
            \', \'${window.$t('MEMBER_LIST_INFORMATION2')}\', 950, 700);\"> ${cell.value}
            </a>`;
        }
      },
      {
        header: 'MEMBER_LIST_MALL_NAME',
        name: 'mallName',
        width: 100,
        align: 'center',
        formatter: () => {
          return $('[name="mallNo"] option:selected').text();
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'MEMBER_LIST_MEMBER_NAME',
        name: 'name',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'MEMBER_LIST_ID',
        name: 'id',
        align: 'center',
        minWidth: 150
      },
      {
        header: 'MEMBER_LIST_NICKNAME',
        name: 'nickname',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'MEMBER_LIST_GRADE',
        name: 'grade',
        align: 'center',
        minWidth: 100,
        formatter: function (cell: any) {
          return cell.value.name;
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'MEMBER_LIST_GROUP',
        name: 'groups',
        align: 'center',
        minWidth: 100,
        formatter: (cell: any) => {
          if (cell.value.length === 0) {
            return '-';
          }
          if (cell.value.length === 1) {
            return cell.value[0].name;
          } else {
            const mallNo = $('select[name="mallNo"]').val();
            return `<a href="javascript:window.open('/member/popup/groups?mallNo=${mallNo}&memberNo=${cell.row.memberNo}', '${window.$t('MEMBER_LIST_GROUP')}', 200, 300);">${cell.value[0].name}</a>`;
          }
        },
        copyOptions: {
          customValue: function (value: any) {
            return value.length > 0 ? value[0].name : '';
          }
        }
      },
      {
        header: 'MEMBER_LIST_MOBILE',
        name: 'mobile',
        align: 'center',
        minWidth: 130
      },
      {
        header: 'MEMBER_LIST_EMAIL2',
        name: 'email',
        align: 'center',
        minWidth: 200
      },
      {
        header: 'MEMBER_LIST_JOIN_DATA',
        name: 'createdDateTime',
        align: 'center',
        minWidth: 150,
        formatter: function (cell: any) {
          if (cell.row.memberStatus === 'WAITING') {
            return '';
          } else {
            return cell.value;
          }
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'MEMBER_LIST_LAST_LOGIN',
        name: 'lastLoginDateTime',
        align: 'center',
        minWidth: 150,
        formatter: function (cell: any) {
          if (cell.row.memberStatus === 'WAITING') {
            return '';
          } else {
            return cell.value;
          }
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'MEMBER_LIST_TYPE',
        name: 'type',
        align: 'center',
        minWidth: 100,
        formatter: function (cell: any) {
          if (cell.value === 'MALL') {
            return window.$t('COMMON_MALLTYPE_MALL');
          } else if (cell.value === 'PAYCO') {
            return window.$t('COMMON_MALLTYPE_PAYCO');
          } else if (cell.value === 'NEOID') {
            return cell.row.memberProviders[0].providerTypeLabel;
          }

          return '';
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'MEMBER_LIST_STATUS',
        name: 'status',
        align: 'center',
        minWidth: 100,
        formatter: function (cell: any) {
          if (cell.value === 'WAITING') {
            return window.$t('MEMBER_LIST_STATUS1');
          }
          if (cell.value === 'ACTIVE') {
            return window.$t('MEMBER_LIST_STATUS2');
          }
          if (cell.value === 'FREEZE') {
            return window.$t('MEMBER_LIST_STATUS3');
          }
          if (cell.value === 'PAUSED') {
            return window.$t('MEMBER_LIST_STATUS4');
          }

          return '';
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'MEMBER_LIST_BLACKLISTED',
        name: 'blacklisted',
        align: 'center',
        minWidth: 100,
        formatter: function (cell: any) {
          return cell.row.blacklisted ? 'Y' : 'N';
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'MEMBER_LIST_COMBINED_POP',
        name: 'combined',
        align: 'center',
        minWidth: 100,
        formatter: function (cell: any) {
          if (cell.value) {
            const mallNo = $('select[name="mallNo"]').val();
            return `<a href="javascript:window.open('/member/popup/link/history?mallNo=${mallNo}&memberNo=${cell.row.memberNo}', '회원통합', 200, 300);">${cell.value}</a>`;
          }

          return 'N';
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'MEMBER_LIST_COMBINED_DT',
        name: 'combinedDateTime',
        align: 'center',
        minWidth: 150,
        formatter: function (cell: any) {
          return cell.value;
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'MEMBER_LIST_PUSH_NOTIFICATION',
        name: 'appPushAgreed',
        align: 'center',
        minWidth: 100,
        formatter: function (cell: any) {
          if (cell.value === true) {
            return 'Y';
          } else {
            return 'N';
          }
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'MEMBER_LIST_SMS_AGREED',
        name: 'smsAgreed',
        align: 'center',
        minWidth: 100,
        formatter: function (cell: any) {
          return cell.value === true ? 'Y' : 'N';
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'MEMBER_LIST_DM_AGREED',
        name: 'directMailAgreed',
        align: 'center',
        minWidth: 100,
        formatter: function (cell: any) {
          return cell.value === true ? 'Y' : 'N';
        },
        copyOptions: {
          useFormattedValue: true
        }
      }
    ],
    options: {
      rowHeaders: ['checkbox'],
      header: {
        height: 33
      },
      columnOptions: {
        minWidth: 50,
        resizable: true
      },
      minRowHeight: 31,
      rowHeight: 31,
      bodyHeight: 480,
      isInitialRequest: true,
      keyColumnName: 'memberNo',
      useClientSort: false,
      pageOptions: {
        perPage: 30,
        page: 1,
        totalCount: 0
      }
    }
  };

  private async apply() {
    let checkedRows = Object.values(this.selectedMemberMap).flat().map(memberNo => ({ memberNo }));
		this.resetSelectedMemberMap();
		
    if (checkedRows.length === 0) {
      alert(this.$t('MEMBER_LIST_ERROR_SELECT_MEMBER_COUNT'));
      return;
    }

    let selectedRows: any = {
      selectedType: 'MEMBER_NO',
      selectedMembers: checkedRows,
      memberCount: checkedRows.length
    };

    this.gradeApply(selectedRows);
  }

  private async gradeApply(selectedRows: any) {
    if (this.$route.query.callback) {
      $(window.opener.location).attr('href', `javascript:window.${this.$route.query.callback}(${JSON.stringify(selectedRows)});`);
    }
    window.close();
  }
  private cancel() {
		this.resetSelectedMemberMap();
    window.close();
  }

  private async created() {
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
  }

  private async mounted() {
    if (this.$route.params.mallNo) {
      // 지급 대상회원
      this.mallNo = this.$route.params.mallNo;
      this.malls = this.malls.filter((mall) => mall.mallNo === Number(this.mallNo));
    }

    await this.initRequest();

    let checkedRows: any[] = JSON.parse(sessionStorage.getItem('checkedMembersInfo') as string);
    if (checkedRows) {
      if (this.$route.query.callback == 'setSearchedMemberInfo') {
        checkedRows.forEach((selectedRow: any) => {
          (this.$refs.itemTable as any).gridFunction('check', [selectedRow]);
        });
      } else {
        checkedRows.forEach((selectedRow: any) => {
          (this.$refs.itemTable as any).gridFunction('check', [selectedRow.memberNo]);
        });
      }
    }
    // this.$nextTick(() => {
    //    popupResize(undefined, 914);
    // });
  }
	
	private onRowChecked({ selected }) {
		this.$set(this.selectedMemberMap, this.getMemberRequest.params.page, selected);
	}
	
}
